import { ActionAny, ActionRequest, createActions } from 'src/utils/createActions';
import { SuggestData } from 'src/state/SuggestState';

export type SuggestRequest =
    ActionRequest<void, string>;
export type SuggestActions =
    ActionAny<void, SuggestData, string>;
export const SUGGEST_ACTIONS =
    createActions<void, SuggestData, string>('SUGGEST');
